import React, { FC, useEffect, useRef, useState } from 'react';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';

interface Props {
  checkSurvey: any;
  id: string;
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType, checkSurvey, id }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '장애인 공제를 받고자하는 대상이 귀한의 기본공제 대상자입니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        confirm: '',
        set: {
          question:
            '장애인 복지법에 의한 등록 자애인 이거나 장애아동 복지지원법에 따른 장애아동 중 발달재활 서비스를  지원받는 사람인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '기본공제를 받을 수 없습니다.',
        status: 'no',
        desc: {
          data: [
            {
              text: (
                <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    // const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      let answerSet = false;
      if (queState.set[0].confirm === 'yes' && queState.set[1].confirm === 'yes') answerSet = true;

      if (!answerSet) {
        awsState.set.set.title = '장애인공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '장애인공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  const confirmEvent = () => {
    checkSurvey('Y', id);
  };

  return (
    <div className="_spouse_question_div">
      <div className="que_box">
        <QuestionBox
          queSet={queSet}
          queState={queState}
          setQueState={setQueState}
          awsState={awsState}
          setAwsState={setAwsState}
        />
      </div>
      {/* {awsState.set.set.status === 'yes' ? (
        <div className="_confirm_btn_div">
          <DefaultButton
            text="기본공제 적용하기"
            clickEvent={e => confirmEvent()}
            styleDef={{ fontSize: '13px', width: '210px', height: '38px' }}
            type="type5"
          />
        </div>
      ) : (
        ''
      )} */}
    </div>
  );
};

export default Spouse;
